// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"U8-z"};